import ReducePermissions from './permissions/utils/reducePermissions';
import ProfileResolvers from './permissions/resolvers/profilePermissionResolvers';
import PERMISSION_KEYS from '../../permissions/profile.permissions';

export default ({ remotePermissions }) => {
  const profilePermissions = ReducePermissions({
    permissionKeys: PERMISSION_KEYS,
    createResolvers: ProfileResolvers,
    sources: { remotePermissions },
  });
  return {
    ...profilePermissions,
  };
};
